import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import type { IExtractedInvoiceData } from '@/typings/extractor'

export default (axios: AxiosInstance) => ({
    extractInvoiceData: async (
        subAccountContextId: string,
        file: File,
        config: AxiosRequestConfig = {},
    ): Promise<IExtractedInvoiceData> => {
        const formData = new FormData()
        formData.set('file', file)

        const { data } = await axios.post<IExtractedInvoiceData>(
            `/guardian/${subAccountContextId}/ai-extractor/extract`,
            formData,
            config,
        )

        return data
    },
})
